var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "main-body"
  }, [_c('div', {
    staticClass: "left-panel"
  }, [_c('h1', [_vm._v(_vm._s(_vm.currentUser.name))]), _c('span', [_vm._v(_vm._s(_vm.currentUser.mobile))]), _c('span', {
    staticClass: "logout-btn",
    on: {
      "click": _vm.logoutFunc
    }
  }, [_vm._v("退出登录")])]), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "register-block"
  }, [_c('h1', [_vm._v("注册公司")]), _c('Form', {
    ref: "formItem",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 80,
      "rules": _vm.ruleValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "公司名",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入公司名",
      "autofocus": true
    },
    model: {
      value: _vm.formItem.name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "name", $$v);
      },
      expression: "formItem.name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "公司代码",
      "prop": "code"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入公司代码"
    },
    model: {
      value: _vm.formItem.code,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "code", $$v);
      },
      expression: "formItem.code"
    }
  })], 1), _vm._l(_vm.formItem.factoryList, function (item, index) {
    return _c('FormItem', {
      key: index,
      attrs: {
        "label": `工厂${index + 1}`,
        "prop": 'factoryList.' + index + '.name',
        "rules": {
          required: true,
          message: `工厂${index + 1}不能为空`,
          trigger: 'blur'
        }
      }
    }, [_c('Row', [_c('Col', {
      attrs: {
        "span": "18"
      }
    }, [_c('Input', {
      attrs: {
        "type": "text",
        "placeholder": "工厂名"
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    })], 1), _c('Col', {
      attrs: {
        "span": "4",
        "offset": "1"
      }
    }, [_c('Button', {
      on: {
        "click": function ($event) {
          return _vm.handleRemove(index);
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1);
  }), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Button', {
    attrs: {
      "type": "dashed",
      "long": "",
      "icon": "md-add"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("增加新厂")])], 1)], 1)], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 2)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }